/**
 * ProductSkeleton - Skeleton loading state for product grid
 * Matches ProductCard dimensions for smooth loading experience
 */

export default function ProductSkeleton({ count = 8 }: { count?: number }) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className="bg-white rounded-[10px] overflow-hidden border border-black/[.08] animate-pulse"
        >
          {/* Image placeholder */}
          <div className="h-[110px] bg-[#f0e9d8]" />

          {/* Content placeholder */}
          <div className="p-[11px] space-y-2">
            {/* Name */}
            <div className="h-3.5 bg-[#f0e9d8] rounded w-3/4" />
            {/* Price */}
            <div className="h-4 bg-[#f0e9d8] rounded w-1/2" />
          </div>
        </div>
      ))}
    </div>
  );
}
